import { CancelableRequest } from '@fino/ng1-request';
import { DataResponse } from '@fino/ng1-response/lib';

export class OverviewService extends CancelableRequest {
  constructor($http, $q, appConfig, configService) {
    'ngInject';
    super({ $http, $q, appConfig, configService });
  }

  get api() {
    return this.appConfig.get().api.path;
  }

  get environment() {
    if (this.configService.isDevelopment()) {
      return '.dev';
    }

    if (this.configService.isTesting()) {
      return '.test';
    }

    return '';
  }

  getSignUrl() {
    return `https://sign${this.environment}.fino.cloud/`;
  }

  getSignatureUrl() {
    return `https://sign${this.environment}.fino.cloud/api/v0/`;
  }

  postOrder(data) {
    return this.$http({
      method: 'POST',
      data,
      url: `${this.api}/orders`,
    }).then(DataResponse.transform('data'));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/overview/overview.service.js